import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Fran\xE7ais",
  code: "fr",
  messages: {
    alert: {
      close: "Fermer"
    },
    authForm: {
      hidePassword: "Masquer le mot de passe",
      showPassword: "Afficher le mot de passe",
      submit: "Continuer"
    },
    banner: {
      close: "Fermer"
    },
    calendar: {
      nextMonth: "Mois suivant",
      nextYear: "Ann\xE9e suivante",
      prevMonth: "Mois pr\xE9c\xE9dent",
      prevYear: "Ann\xE9e pr\xE9c\xE9dente"
    },
    carousel: {
      dots: "Choisir la diapositive \xE0 afficher",
      goto: "Aller \xE0 {slide}",
      next: "Suivant",
      prev: "Pr\xE9c\xE9dent"
    },
    chatPrompt: {
      placeholder: "\xC9crivez votre message ici..."
    },
    chatPromptSubmit: {
      label: "Envoyer"
    },
    colorMode: {
      dark: "Sombre",
      light: "Clair",
      switchToDark: "Passer en mode sombre",
      switchToLight: "Passer en mode clair",
      system: "Syst\xE8me"
    },
    commandPalette: {
      back: "Retour",
      close: "Fermer",
      noData: "Aucune donn\xE9e",
      noMatch: "Aucune donn\xE9e correspondante",
      placeholder: "Tapez une commande ou recherchez..."
    },
    contentSearch: {
      links: "Liens",
      theme: "Th\xE8me"
    },
    contentSearchButton: {
      label: "Rechercher..."
    },
    contentToc: {
      title: "Sur cette page"
    },
    dashboardSearch: {
      theme: "Th\xE8me"
    },
    dashboardSearchButton: {
      label: "Rechercher..."
    },
    dashboardSidebarCollapse: {
      collapse: "Replier la barre lat\xE9rale",
      expand: "D\xE9ployer la barre lat\xE9rale"
    },
    dashboardSidebarToggle: {
      close: "Fermer la barre lat\xE9rale",
      open: "Ouvrir la barre lat\xE9rale"
    },
    error: {
      clear: "Retour \xE0 l'accueil"
    },
    fileUpload: {
      removeFile: "Supprimer {filename}"
    },
    header: {
      close: "Fermer le menu",
      open: "Ouvrir le menu"
    },
    inputMenu: {
      create: 'Cr\xE9er "{label}"',
      noData: "Aucune donn\xE9e",
      noMatch: "Aucune donn\xE9e correspondante"
    },
    inputNumber: {
      decrement: "Diminuer",
      increment: "Augmenter"
    },
    modal: {
      close: "Fermer"
    },
    pricingTable: {
      caption: "Comparaison des plans de prix"
    },
    prose: {
      codeCollapse: {
        closeText: "R\xE9duire",
        name: "code",
        openText: "D\xE9velopper"
      },
      collapsible: {
        closeText: "Masquer",
        name: "propri\xE9t\xE9s",
        openText: "Afficher"
      },
      pre: {
        copy: "Copier le code dans le presse-papiers"
      }
    },
    selectMenu: {
      create: 'Cr\xE9er "{label}"',
      noData: "Aucune donn\xE9e",
      noMatch: "Aucune donn\xE9e correspondante",
      search: "Rechercher..."
    },
    slideover: {
      close: "Fermer"
    },
    table: {
      noData: "Aucune donn\xE9e"
    },
    toast: {
      close: "Fermer"
    }
  }
});
